import { useEffect, useState } from "react";
import "./LoginPage.css";
import WarningAlert from "../components/sweeAlerts/WarningAlert";
import { CreatePayment, GetCreditStatusPhone } from "../api/api";
import ErrorToast from "../components/toasts/ErrorToast";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";

const ReChargeWallet = () => {
  const [phone_number, setPhoneNumber] = useState("");
  const [amount, setAmount] = useState(0); // عدد خالص
  const [displayAmount, setDisplayAmount] = useState(""); // مقدار فرمت‌شده برای input
  const [errorMessage, setErrorMessage] = useState("");
  const [amountErrorMessage, setAmountErrorMessage] = useState("");
  const [creditStatus, setCreditStatus] = useState(null);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const phone_number = searchParams.get("p");
    if (phone_number) {
      handleInputUser(phone_number);
    }

    if(mobilePattern.test(phone_number)){
      GetCreditStatusPhone({
        phone_number: Number(phone_number),
      }).then(({ data }) => {
        setCreditStatus(data.credit);
      });
    }
  }, []);

  const mobilePattern = /^(\+98|0)?9\d{9}$/;

  const handleInputUser = (val) => {
    setPhoneNumber(val);
    if (val == "") {
      setErrorMessage("");
      return 0;
    }
    if (mobilePattern.test(val)) {
      setErrorMessage(null);
    } else {
      setErrorMessage("شماره همراه وارد شده معتبر نمی باشد");
    }
  };

  const handleAmountChange = (val) => {
    const numericVal = val.replace(/,/g, "");

    if (isNaN(numericVal)) {
      setAmountErrorMessage("مبلغ را به صورت عددی وارد کنید");
      setDisplayAmount(val);
      return;
    }

    const number = Number(numericVal);
    setAmount(number);
    setDisplayAmount(number.toLocaleString("en-US"));
    setAmountErrorMessage(null);
  };

  const handleSubmit = (val) => {
    // مثل PaymentAmountModal
    if (!amount || isNaN(amount) || amount <= 0) {
      return ErrorToast("مبلغ وارد شده معتبر نمی‌باشد");
    }
    
    WarningAlert(
      "",
      "از شارژ کیف پول به شماره موبایل " +
        phone_number +
        " به مبلغ " +
        displayAmount +
        " تومان اطمینان دارید؟", 'بله', 'انصراف'
    ).then((res) => {
      if (res.value) {
        CreatePayment({
          amount,
          phone_number,
        })
          .then(({ data }) => {
            window.location.href =
              "https://payment.zarinpal.com/pg/StartPay/" +
              data.payment.authority;
          })
          .catch((error) => {
            // مثل PaymentAmountModal
            if (!error.response) {
              ErrorToast("عدم ارتباط با سرور. اتصال اینترنت خود را بررسی کنید.");
              return;
            }

            const { status, data } = error.response;

            switch (status) {
              case 422: {
                const firstError = Object.values(data)?.[0];
                ErrorToast(firstError || "اطلاعات وارد شده نامعتبر است");
                break;
              }

              case 400:
                if (data?.message) {
                  ErrorToast(data.message);
                } else {
                  const firstError = Object.values(data)?.[0];
                  ErrorToast(firstError || "درخواست پرداخت ناموفق بود");
                }
                break;

              case 503:
                ErrorToast(
                  "در حال حاضر ارتباط با درگاه پرداخت برقرار نیست. لطفاً بعداً تلاش کنید.",
                );
                break;

              case 404:
                ErrorToast("کاربر یا اطلاعات پرداخت یافت نشد");
                break;

              default:
                ErrorToast("خطای غیرمنتظره‌ای رخ داده است");
            }
          });
      }
    });
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>شارژ کیف پول</title>
      </Helmet>
      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-4">
            {/* Register */}
            <div className="card">
              <div className="card-body">
                {/* Logo */}
                <div className="app-brand justify-content-center">
                  <h4>شارژ کیف پول</h4>
                </div>

                <form id="formAuthentication" className="mb-3 p-3">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      شماره همراه
                    </label>
                    <input
                      className="form-control text-start"
                      placeholder="شماره همراه متصل به کیف پول را وارد کنید"
                      autoFocus
                      dir="ltr"
                      value={phone_number}
                      onChange={(e) => handleInputUser(e.target.value)}
                    />
                    <div className="text-danger" style={{ fontSize: "85%" }}>
                      {errorMessage}
                    </div>
                  </div>
                  <div className="mb-3 form-password-toggle">
                    <div className="d-flex justify-content-between">
                      <label className="form-label" htmlFor="otp">
                        مبلغ(تومان)
                      </label>
                    </div>
                    <div className="input-group input-group-merge">
                      <input
                        id="otp"
                        className="form-control text-start"
                        aria-describedby="otp"
                        dir="ltr"
                        placeholder="مبلغ مورد نظر برای شارژ را وارد کنید"
                        value={displayAmount}
                        onChange={(e) => handleAmountChange(e.target.value)}
                      />
                    </div>
                    <div className="text-danger" style={{ fontSize: "85%" }}>
                      {amountErrorMessage}
                    </div>
                  </div>
                  <div className="mb-3">
                    <button
                      className="btn btn-success-app d-grid w-100"
                      type="button"
                      onClick={handleSubmit}
                    >
                      تایید
                    </button>
                  </div>
                </form>
                {creditStatus || creditStatus == 0 ? (
                  <p className="text-center">
                    اعتبار فعلی:{" "}
                    <b className="text-success-app">{creditStatus}</b> تومان
                  </p>
                ) : null}
              </div>
            </div>
            {/* /Register */}
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default ReChargeWallet;